import React from 'react';
import { Community } from 'store/community/type';
import {
  calculateTimeStamp,
  getAPIErrorMessage,
  makeAuthorizationConfig,
} from 'utils';
import { useRouter } from 'next/router';
import { useCookies } from 'react-cookie';
import { AxiosResponse } from 'axios';
import { PostNoticeLikeAPI } from 'api/community';
import styled from 'styled-components';

interface IProps {
  feed: Community;
  callback?: () => void;
}

const NoticeCard: React.FC<IProps> = ({ feed, callback }: IProps) => {
  const branch = feed.branch !== null ? feed.branch : { name: '로컬 스티치' };
  const image = feed.images;
  const [cookies] = useCookies();

  const router = useRouter();

  const clickDetail = id => {
    router.push(`/community/notice/${id}`);
  };

  const likeNotice = async () => {
    const config = makeAuthorizationConfig(cookies.access_token);

    const response: AxiosResponse = await PostNoticeLikeAPI(feed.id, config);

    if (response.status > 400) {
      alert(getAPIErrorMessage(response));
      return;
    }

    // location.reload()
    callback();
  };

  return (
    <div className="noti-box">
      <div className="in-hgroup">
        <em>공지사항</em>
        <div className="pro-info">
          <em>{branch.name}</em>
          <span>{calculateTimeStamp(feed.created_at)}</span>
        </div>
      </div>
      <div className="info">
        <div
          className="img"
          style={{ cursor: 'pointer' }}
          onClick={() => clickDetail(feed.id)}
        >
          {image.length === 0 ? null : <img src={image[0].image} alt="" />}
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: feed.content }}
          onClick={() => clickDetail(feed.id)}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div
        className="side-info"
        style={{ display: 'flex', alignItems: 'center' }}
      >
        <LikeButton onClick={likeNotice}>
          <img
            src={`/images/heart-${feed.is_liked ? 'filled' : 'outline'}.svg`}
            style={{ width: 16, height: 16 }}
            alt="좋아요"
          />
          <span style={{ marginLeft: 4 }}>{feed.like_count}</span>
        </LikeButton>
        <a onClick={() => clickDetail(feed.id)}>
          <span>코멘트</span>
          {feed.comment_count}
        </a>
      </div>
    </div>
  );
};

const LikeButton = styled.div`
  display: inline-block;
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
`;

export default NoticeCard;
